/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { WorkingModeDiff } from './workingModeDiff';

export type GenericApiResponseWorkingModeDiffData = WorkingModeDiff | null;
